module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":"The development time of a mobile app from scratch usually takes about 6-12 months.","text":"We have reduced this time<br>to <span class=\\"text-accent\\">2 weeks</span>"},"ru":{"heading":"Обычно время разработки мобильного приложения с нуля - около 6-12 месяцев","text":"Мы сократили это время<br>до <span class=\\"text-accent\\">2-х недель</span>"}}')
  delete Component.options._Ctor
}
